module.exports = __webpack_public_path__ + "static/media/ride-designer.08296f29.png";